import Api from "@coach/js/services/Api";

export default {
  // async getPlans(query = null) {
  //   let request = `plans`;
  //   if (query) {
  //     request += "?" + query;
  //   }
  //   return Api.get(request);
  // },
  async get(id, query = null) {
    let request = `workout_plans/${id}`;
    if (query) {
      request += "?" + query;
    }
    return Api.get(request);
  },
  async updateExercise(id, payload) {
    return Api.put(`workout_plan_exercises/${id}`, payload);
  },
  async deleteExercise(id) {
    return Api.delete(`workout_plan_exercises/${id}`);
  }
};
